<template>
  <!--begin::Modal - Create App-->
  <div
    class="modal fade"
    id="kt_modal_create_info"
    ref="createAppModalRef"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="c-umt1st">Các cam kết</h2>
          <!--end::Modal title-->

          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body py-lg-2 px-lg-5">
          <!--begin::Stepper-->
          <div
            class="p-4 stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid"
            id="kt_modal_create_app_stepper"
            ref="createAppRef"
          >
            <!--begin::Content-->
            <div>
                <p class="d-flex">
                   <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span>
             Tôi xác nhận rằng tôi hiểu rõ tất cả các thông tin tôi đã điền trong đơn này và 
                    tất cả các thông tin tôi cung cấp là hoàn toàn chính xác và được điền đầy đủ. 
                    Tôi sẽ thông báo ngay cho Nhà Trường nếu tôi có thay đổi thông tin cá nhân. 
                </p>
                <p class="d-flex">
                    <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span> Tôi hoàn toàn hiểu rõ rằng nếu tôi cung cấp sai sự thật hoặc không nộp đầy đủ hồ sơ liên quan 
đến quá trình xét hồ sơ của tôi thì hồ sơ nhập học hay đăng ký nhập học của tôi sẽ bị hủy bỏ.
                </p>
                <p class="d-flex">
                    <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span> Tôi xác nhận tôi đã đồng ý cho Nhà Trường cung cấp thông tin về quá trình học tập của tôi cho người thân/người quen liệt kê 
trong phần Thông tin người thân.
                </p>
                <p class="d-flex">
                    <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span> Tôi hiểu rõ rằng nếu tôi ký xác nhận cung cấp thông tin là tôi đồng ý cung cấp các thông tin cá nhân,
 kết quả học tập, và các thông tin về chi phí học tập tại trường.  Sau khi xác nhận đúng người được uỷ quyền, Nhà Trường được toàn quyền cung cấp 
 thông tin cho các cá nhân được uỷ quyền này.
                </p>
                <p class="d-flex">
                    <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span> Tôi hiểu rõ rằng Nhà Trường cũng có thể cung cấp thông tin học tập và cá nhân của tôi cho cơ quan chính quyền Việt Nam.
                </p>
                <p class="d-flex">
                    <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span> Tôi hiểu rằng Nhà Trường có quyền hoãn kỳ nhập học cũng như thay đổi chương trình học, môn học, các chi phí, 
nhân sự và các kế hoạch khác mà không phải báo trước.
                </p>
                <p class="d-flex">
                    <span class="svg-icon svg-icon-primary svg-icon-2 me-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr085.svg" />
                    </span> Tôi xác nhận rằng tôi đã đọc, hiểu rõ và chấp nhận các điều khoản bảo mật của UMT.
                </p>
            </div>
            <!--end::Content-->
          </div>
          <!--end::Stepper-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - Create App-->
</template>

<style lang="scss" scoped>
.el-input--suffix .el-input__inner {
  background-color: #f5f8fa;
}

.el-input__inner {
  background-color: #f5f8fa;
}
.table-bordered td, .table-bordered th {
    border: 1px solid #dee2e6;
}
.table-bordered thead td, .table-bordered thead th {
    border-bottom-width: 2px;
}
.table-bordered td,.table-bordered th {
  vertical-align: middle;
}
</style>